export const conversionSource = {
  STANDALONE: 'Landingpage',
  EMBEDDED: 'Widget',
  FB_LEAD_ADS: 'Facebook Lead Ads',
  POST_CONVERSION: 'Landingpage (nach vorheriger Aktivität)',
  STANDALONE_SECONDARY: 'Landingpage (verlinkt von anderer Landingpage)',
}
